<template>
  <div class="mainPage">
    <p id="headPage">VOUCER</p>
    <div class="cardRow">
      <!--   -->
      <div class="inRow">
        <div class="card" id="startBalance">
          <p id="titleCard">Saldo Awal</p>
          <p id="amountCard">{{formatUang(totalBalance.startBalance)}}</p>
        </div>
        <div class="card" id="inCard">
          <p id="titleCard">Kas Masuk</p>
          <p id="amountCard">{{formatUang(totalBalance.addDebt)}}</p>
        </div>
        <div class="card" id="outCard">
          <p id="titleCard">Kas Keluar</p>
          <p id="amountCard">{{formatUang(totalBalance.payDebt)}}</p>
        </div>
        <div class="card" id="balanceCard">
          <p id="titleCard">Saldo Akhir</p>
          <p id="amountCard">{{formatUang(totalBalance.endBalance)}}</p>
        </div>
      </div>
    </div>
    <div class="filterRow">
      <div class="filterGrid">
        <div class="filterItem" v-if="role == 'owner'">
          <p id="inputTitle">Cabang</p>
          <b-select v-model="findBranchId" @change="this.getVoucer">
            <option value="0" disabled>Pilih Cabang </option>
            <option v-for="e in this.branches" :key="e.id" :value="e.id"> {{e.branchName}} </option>
          </b-select>
        </div>
        <div class="filterItem">
          <p id="inputTitle">Jenis</p>
          <b-select v-model="findType" @change="this.getVoucer">
            <option :value=1> Pemasukan </option>
            <option :value=2> Pengeluaran </option>
          </b-select>
        </div>
        <div class="filterItem">
          <p id="inputTitle">Status</p>
          <b-select v-model="findStatus"  @change="this.getVoucer">
            <option :value=1> Urgent </option>
            <option :value=2> Planing </option>
          </b-select>
        </div>
        <div class="filterItem">
          <p id="inputTitle">Dari</p>
          <b-input type="date"  v-model="startDate"  @change="this.getVoucer"></b-input>
        </div>
        <div class="filterItem">
          <p id="inputTitle">Sampai</p>
          <b-input type="date" v-model="endDate"  @change="this.getVoucer"></b-input>
        </div>
        <div class="filterItem">
          <p id="inputTitle">Cari</p>
          <b-input type="text" v-model="keyword"  @change="this.getVoucer" placeholder="Ketik keyword..."></b-input>
        </div>
      </div>
    </div>
    <div class="pageNation inRow">
      <div class="actionButtons">
        <b-button id="addModal" @click.prevent="showAdd()" v-if="role == 'cashier'">Tambah</b-button>
        <b-button id="resetFilter" @click.prevent="resetFilter()">Reset</b-button>
        <b-button id="transferButton" @click.prevent="showTransfer()" v-if="role == 'cashier'">Transfer</b-button>
        <button @click.prevent="printCsv()" id="printer" title="Print CSV">
          <img src="../assets/printer.png" id="printer" alt="Print">
        </button>
      </div>
      <div class="numberPage">
        <button
        id="button-page"
          v-for="page in getPaginationArray()"
          :key="page.text"
          @click="!page.isEllipsis && changePage(page)"
          :class="{ active: currentPage === page }"
          :disabled="page === '...'"
        >
          <p>{{ page }}</p>
        </button>
      </div>
    </div>
    <div class="tableRow">
      <div class="inRow">
        <lord-icon
          v-if="this.isLoading"
          src="https://cdn.lordicon.com/dpinvufc.json"
          trigger="loop"
          style="width:300px;height:300px">
        </lord-icon>
      </div>
      
      <table v-if="!isLoading" class="table-bordered table-hover" id="tableData">
        <thead>
          <tr>
            <th>#</th>
            <th>Tanggal</th>
            <th>No.Reff</th>
            <th>Cabang</th>
            <!-- <th>Jenis</th> -->
            <th>Keterangan</th>
            <th>Jumlah</th>
            <th colspan="4">Aksi</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(e,index) in this.voucers" :key="e.id">
            <td>{{ index+1 }}</td>
            <td>{{formatDate(e.date)}} </td>
            <td> {{e.refNo}} </td>
            <td> {{e.Branch.branchName}} </td>
            <!-- <td v-if="e.type == 1" class="text-center"> <img id="status" src="../assets/masuk.png" alt=""> </td>
            <td v-if="e.type == 2" class="text-center"> <img id="status" src="../assets/keluar.png" alt=""> </td> -->
            <td> {{e.notes}}  <img v-if="e.isEdit" id="edited" src="../assets/edited.png" alt=""> </td>
            <td class="uang" :class="{ 'green-amount': e.type == 1, 'red-amount': e.type == 2 }"> {{ formatUang(e.amount)}} </td>
            <td id="action" class="text-center" v-if="role == 'cashier'">
                <button @click.prevent="setPrintData(e)" title="Print" >
                  <img src="../assets/print2.png" alt="">
                </button>
              </td>
              <td id="action" class="text-center" >
                <button @click.prevent="changeStatus(e)" title="Print" >
                  <img v-if="e.isOpen" src="../assets/gembokGreen.png" alt="">
                  <img v-if="!e.isOpen" src="../assets/gembokRed.png" alt="">
                </button>
              </td>
              <!-- <td v-if="e.isEdit == 1" class="text-center"> <img id="edited" src="../assets/edited.png" alt=""> </td> -->
              <!-- <td id="action" class="text-center" >
                <button @click.prevent="changeStatus(e.id)" title="Ubah Status Open" >
                  <lord-icon
                    src="https://cdn.lordicon.com/wloilxuq.json"
                    trigger="hover">
                  </lord-icon>
                </button>
            </td> -->
            <td id="action" class="text-center"  v-if="role == 'cashier' && e.isOpen" >
              <button @click.prevent="showEdit(e)" title="Edit" >
                <img src="../assets/edit.png" alt="">
              </button>
            </td>
            <td id="action" class="text-center"  v-if="role == 'cashier'">
              <button @click.prevent="confirmDelete(e.id)" title="Hapus">
                <img src="../assets/trash.png" alt="">
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Transfermodal -->
  <div class="modal" id="transferModal" tabindex="-1">
  <!-- <div class="modal-dialog"> -->
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Transfer Antar Perusahaan</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true" >&times; </span>
        </button>
      </div>
      <div class="modal-body">
        <form @submit.prevent="transferVoucer()">
          <div class="inRow">
            <div class="inCol" >
              <p id="titleModal">Tujuan Transfer</p>
              <b-select v-model="transfer.BranchToId" required>
                <option :value="e.id" v-for="e in this.listBranch" :key="e.id">{{ e.branchName }}</option>
              </b-select>
            </div>
            <div class="inCol">
              <p id="titleModal">Tanggal</p>
              <b-input v-model="transfer.date" type="date" required></b-input>
            </div>

            <div class="inCol">
              <p id="titleModal">Jumlah</p>
              <b-input class="text-right" v-model="transfer.amount" type="text" @input="currencyNumber($event)"  required></b-input>
            </div>
          </div>

          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
            <button type="submit" class="btn btn-primary">Tambah</button>
          </div>
        </form>
      </div>
    </div>
  <!-- </div> -->
</div>
      <!-- Main Modal -->
  <div class="modal" id="mainModal" tabindex="-1">
  <!-- <div class="modal-dialog"> -->
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Voucer</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true" >&times; </span>
        </button>
      </div>
      <div class="modal-body">
        <form @submit.prevent="isEdit ? editVoucer() : addVoucer()">
          <div class="inRow">
            <div class="inCol" v-if="role == 'owner'">
              <p id="titleModal">Nama Cabang</p>
              <b-select v-model="BranchId" required>
                <option :value="e.id" v-for="e in this.branches" :key="e.id">{{ e.branchName }}</option>
              </b-select>
            </div>
            <div class="inCol">
              <p id="titleModal">Tanggal</p>
              <b-input v-model="date" type="date" required></b-input>
            </div>
            <div class="inCol">
              <p id="titleModal">Jenis Voucer</p>
              <b-select v-model="type" required>
                <option value="1">Pemasukan</option>
                <option value="2">Pengeluaran</option>
              </b-select>
            </div>
            <!-- <div class="inCol" v-if="this.type == 2">
              <p id="titleModal">Status Voucer</p>
              <b-select v-model="status">
                <option value="1">Urgent</option>
                <option value="2">By Planing</option>
              </b-select>
            </div> -->
            <div class="inCol">
              <p id="titleModal">Jumlah</p>
              <b-input class="text-right" v-model="amount" type="text" @input="currencyNumber($event)"  required></b-input>
            </div>
          </div>
          <div class="inRow">
          </div>
          <div class="inRow">
            <div class="inCol">
              <p id="titleModal">Keterangan</p>
              <b-input v-model="notes" name="detail" type="text" required></b-input>
            </div>
          </div>

        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
          <button type="submit" class="btn btn-primary">Tambah</button>
        </div>
      </form>
      </div>
    </div>
  <!-- </div> -->
  </div>
<!-- Print -->
  <div id="printArea">

    <div class="headPrint">
      <p id="titlePrint" v-if="this.print.type == 1">Voucer Penerimaan</p>
      <p id="titlePrint" v-if="this.print.type == 2">Voucer Pengeluaran</p>
      <p id="brancName"> {{ print.branchName }} </p>
      <p id="datePrint"> {{ print.date }} </p>
    </div>
    <hr>
    <div class="mainPrint">
      <table class="table table-borderless" id="printTable">
          <tr>
            <td id="keyTable">Nomor</td>
            <td id="titikDua">:</td>
            <td>{{ print.nomor }}</td>
          </tr>
          <tr>
            <td id="keyTable">Jumlah</td>
            <td id="titikDua">:</td>
            <td>Rp.{{ print.amount }}</td>
          </tr>
          <tr>
            <td id="keyTable">Keterangan</td>
            <td id="titikDua">:</td>
            <td>{{ print.notes }}</td>
          </tr>
      </table>
      <hr>
    </div>
    <div class="signArea">
      <div class="inRow">
        <div class="inCol">
          <p id="name">Kasir</p>
          <p>(............................)</p>
        </div>
        <div class="inCol" v-if="this.print.type == 1">
          <p id="name">Pemberi</p>
          <p>(............................)</p>
        </div>
        <div class="inCol" v-if="this.print.type == 2">
          <p id="name">Penerima</p>
          <p>(............................)</p>
        </div>
        <div class="inCol">
          <p id="name">Akuntansi</p>
          <p>(............................)</p>
        </div>
        <div class="inCol">
          <p id="name">Direktur</p>
          <p>(............................)</p>
        </div>
      </div>
    </div>
    <hr>
  </div>
</div>
</template>

<script>
import axios  from '../API/axios'
import Swal from "sweetalert2";
import moment from 'moment'
import csvDownload from 'json-to-csv-export'
import html2pdf from "html2pdf.js";
export default {
  name: "Voucer",
  data() {
    return  {
      id: 0,
      voucers: [],
      currentPage: 1,
      perPage: 40,
			totalPage : 1,
      isLoading: false,
      isEdit: false,
      totalBalance: {},
      
      // filter
      findBranchId: 0,
      findType: "",
      findStatus: "",
      startDate: "",
      endDate: "",
      keyword: "",
      listBranch: [],

      // modal
      BranchId: 0,
      amount: '',
      notes: "",
      status: 1,
      date: "",
      type: "",

      transfer: {
        amount: 0,
        BranchToId: 0,
        date: moment(new Date).format('YYYY-MM-DD')
      },

      // print
      print: {
        branchName: '',
        date: '',
        nomor: '',
        notes: '',
        amount: '',
        type: 0
      }

    }
  },
  created() {
    this.$store.dispatch("getBranch")
    this.getVoucer()
    this.getBranch()
  },
  computed: {
    branches() {
      return this.$store.state.branches
    },
    role() {
      return localStorage.getItem("role");
    },
  },  
  methods: {
    resetFilter() {
      this.findBranchId= 0
      this.currentPage = 1
      this.findType= ""
      this.findStatus= ""
      this.startDate= ""
      this.endDate= ""
      this.getVoucer()
    },
    showAdd() {
      this.isEdit = false
      this.date = moment(new Date).format("YYYY-MM-DD")
      $('#mainModal').modal('show')
    },
    showTransfer() {
      this.transfer.date = moment(new Date).format("YYYY-MM-DD")
      $('#transferModal').modal('show')
    },

    setPrintData(e) {
      this.print.branchName = e.Branch.branchName,
      this.print.date = moment(e.date).format('DD-MM-YYYY')
      this.print.nomor = e.refNo
      this.print.amount = this.formatUang(e.amount)
      this.print.notes = e.notes
      this.print.type = e.type
      this.exportToPDF()
    },

    exportToPDF() {
      this.isLoading = true
      document.getElementById('printArea').style.display='block'
      html2pdf(document.getElementById('printArea'),  {
        margin: 1,
        filename: "Voucer.pdf",
      }).then(e => {
        document.getElementById('printArea').style.display='none'
        this.isLoading = false
      })
    },

    showEdit(e) {
      this.id = e.id
      this.isEdit = true
      $('#mainModal').modal('show')
      this.BranchId=  e.BranchId,
      // OrderId=  e.OrderId,
      this.date=  e.date,
      this.status=  e.status,
      this.type=  e.type,
      this.notes=  e.notes,
      this.amount=  this.setEditAmount(e.amount)
    },

    currencyNumber(event, target) {
        console.log(event, "===================");
        let currentValue = event.trim().split('.').filter(e => e != '.' ).join('')

        console.log(currentValue, typeof currentValue," -----------");
        if( Number.isNaN(Number(currentValue))) {

          this.amount = this.formatUang(currentValue.split('').filter(e => !Number.isNaN( Number(e))).join(''))
          return
        }
        // currentValue = this.amount
        this.amount = this.formatUang(currentValue)
        this.transfer.amount = this.formatUang(currentValue)
    },
    setEditAmount(currentValue) {
      let result = 0
      if( Number.isNaN(Number(currentValue))) {
          // this.amount = 10
          this.amount = this.formatUang(currentValue.split('').filter(e => !Number.isNaN( Number(e))).join(''))
          return
        }
        // currentValue = this.amount
      result = this.formatUang(currentValue)
      return result 
    },


    async changeStatus(e) {
      
      try {
        if(e.status == 2 && e.amount > 2000000) return  Swal.fire('Maaf', 'data anda tidak dapat diubah', 'error');
        let data2 = await axios({
          method: "patch",
          url: `/voucer/isopen/${e.id}`,
          headers: {
            access_token: localStorage.getItem("access_token")
          },
        })
        Swal.fire('Berhasil', 'Data berhasil diproses', 'success');
        this.getVoucer()
      } catch(err) {
        console.log(err);
        Swal.fire('Maaf', 'Periksa Kembali data anda', 'error');
      }
    },
    formatDate(date) {
      let result = ''
      if(date) return moment(date).format("DD-MM-YYYY")
    },
    cekStatus(data) {
      let result = ""
      if(data == 2) {
        result = 'By Planing'
      } else if(data == 1) {
        result= 'Urgent'
      }
      return result
    },
    formatUang(data) {
      // console.log(data);
        
      let uang = "";
        if(data) {
          data = data.toString();
          for (let i = 0; i < data.length; i++) {
            if ((data.length - i) % 3 == 0 && i !== 0) {
            uang += `.${data[i]}`;
            } else {
            uang += data[i];
            }
          }
        }
        return uang
    },
    async getBranch() {

      try {

        let {data} = await axios({
          method: 'get',
          url: '/user/branch2',
          headers: {
            access_token: localStorage.getItem("access_token")
          }
        })
        this.listBranch = data

      } catch(err) {
        console.log(err);
      }
    },
    async getVoucer() {
      this.isLoading = true
      try {
        
        let {data} = await axios({
          method: "GET",
          url: "/voucer",
          headers: {
            access_token: localStorage.getItem("access_token")
          },
          params: {
            startDate: this.startDate,
            endDate: this.endDate,
            page: this.currentPage,
            limit: this.perPage,
            BranchId: this.findBranchId,
            type: this.findType, 
            status: this.findStatus, 
            keyword : this.keyword
          }
        })
        console.log(data);
        this.voucers = data.data2.result
        let totalPage = Math.ceil(data.data2.dataLength / this.perPage)
				this.totalPage = totalPage
        this.isLoading = false
        this.totalBalance = data.totalBalance
      } catch(err) {
        this.isLoading = false
        console.log(err);
      }

    },
    async printCsv() {
      this.isLoading = true
      try {
        
        let {data} = await axios({
          method: "GET",
          url: "/voucer/print",
          headers: {
            access_token: localStorage.getItem("access_token")
          },
          params: {
            startDate: this.startDate,
            keyword: this.keyword,
            BranchId: this.findBranchId,
            type: this.findType, 
            status: this.findStatus, 
          }
        })
        const dataToConvert = {
          data: data,
          filename: 'Voucer',
          delimiter: ',',
        }
        csvDownload(dataToConvert)
        this.isLoading= false
      } catch(err) {
        this.isLoading = false
        console.log(err);
      }
      
    },
    
    async addVoucer() {
      
      try {
        $('#mainModal').modal('hide')
        let status = null
        if(this.type == 2) {
          status = this.status
        }

        let amount = this.amount.trim().split('.').filter(e => e != '.' ).join('')
        let data =  {
          BranchId:  this.BranchId,
          date:  this.date,
          status:  this.status,
          type:  this.type,
          notes:  this.notes,
          amount:  amount,
        }

        let data2 = await axios({
          method: "POST",
          url: "/voucer",
          data: data,
          headers: {
            access_token: localStorage.getItem("access_token")
          },
        })
        this.BranchId=  0
        this.date=  ""
        this.status=  1
        this.type=  ""
        this.notes=  ""
        this.OrderId=  ""
        this.amount=  0
        Swal.fire('Berhasil', 'Data Berhasil Ditambahkan', 'success');
        this.getVoucer()
      } catch(err) {
        console.log(err);
        Swal.fire('Maaf', 'Periksa Kembali data anda', 'error');
      }
    },
    async transferVoucer() {

      try {
        let status = null
        if(this.type == 2) {
          status = this.status
        }

        let amount = this.transfer.amount.trim().split('.').filter(e => e != '.' ).join('')
        let data =  {
          date:  this.date,
          BranchToId : this.transfer.BranchToId,
          amount:  amount,
        }

        let data2 = await axios({
          method: "POST",
          url: "/voucer/transfer",
          data: data,
          headers: {
            access_token: localStorage.getItem("access_token")
          },
        })
        $('#transferModal').modal('hide')
        this.amount=  0
        Swal.fire('Berhasil', 'Data Berhasil Ditambahkan', 'success');
        this.getVoucer()
      } catch(err) {
        console.log(err);
        Swal.fire('Maaf', 'Periksa Kembali data anda', 'error');
      }
    },

    async editVoucer() {

      try {
        
        let payload =  {
          BranchId:  this.BranchId,
          date:  this.date,
          status:  this.status,
          type:  this.type,
          notes:  this.notes,
          amount:  this.amount.trim().split('.').filter(e => e != '.' ).join(''),
          isOpen : false
        }

        let data2 = await axios({
          method: "put",
          url: `/voucer/${this.id}`,
          data: payload,
          headers: {
            access_token: localStorage.getItem("access_token")
          },
        })
        $('#mainModal').modal('hide')
        this.getVoucer()
        this.BranchId=  0
        this.date=  ""
        this.status=  ""
        this.type=  ""
        this.notes=  ""
        this.OrderId=  ""
        this.amount=  0
        this.id=  0
        Swal.fire('Berhasil', 'Data Berhasil Ditambahkan', 'success');
        
      } catch(err) {
        console.log(err);
        Swal.fire('Maaf', 'Periksa Kembali data anda', 'error');
      }
    }, 

    async deleteData(id) {
      
      try {
        
        let data = await axios.delete(`/voucer/${id}`, {
          headers: {
            access_token: localStorage.getItem("access_token")
          },
        })
        Swal.fire('Berhasil', 'Data Berhasil Dihapuskan', 'success');
        this.getVoucer()

      } catch(err) {
        Swal.fire('Maaf', 'Periksa Kembali data anda', 'error');

      } 
    },
    async confirmDelete(id) {
      
      try {
        let data = await Swal.fire({
            title: 'Yakin?',
            text: 'Apakah Yakin ',
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Hapus!!',
        })
        if (data.isConfirmed) {
            this.deleteData(id);
            this.getVoucer()
        } else {
                Swal.fire('Ok', 'Proses anda berhasil dibatalkan', 'error');
              }
              
              
            } catch(err) {
              
              Swal.fire('Maaf', 'Proses anda berhasil dibatalkan', 'error');
      }
    },
    getPaginationArray() {
      
        const pages = [];
        const totalPages = this.totalPage;
        const currentPage = this.currentPage;

        const startPage = Math.max(1, currentPage - 2);
        const endPage = Math.min(totalPages, currentPage + 2);
      
        

        if (startPage > 1) {
            pages.push(1);
            if (startPage > 2) pages.push('...');
        }

        for (let i = startPage; i <= endPage; i++) {
            pages.push(i);
        }

        if (endPage < totalPages) {
            if (endPage < totalPages - 1) pages.push('...');
            pages.push(totalPages);
        }
        
        return pages

    },

    changePage(page) {
        if (page < 1 || page > this.totalPage) return; // Validasi halaman
        this.currentPage = page;        
        this.getVoucer()
    },
  }
}
</script>

<style scoped>
/* Modern CSS Variables */
:root {
  --primary-gradient: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  --success-gradient: linear-gradient(135deg, #4ade80 0%, #22c55e 100%);
  --danger-gradient: linear-gradient(135deg, #f87171 0%, #ef4444 100%);
  --warning-gradient: linear-gradient(135deg, #fbbf24 0%, #f59e0b 100%);
  --info-gradient: linear-gradient(135deg, #60a5fa 0%, #3b82f6 100%);
  --dark-gradient: linear-gradient(135deg, #374151 0%, #111827 100%);
  --card-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
  --card-shadow-hover: 0 20px 40px -10px rgba(0, 0, 0, 0.15), 0 15px 20px -5px rgba(0, 0, 0, 0.08);
}

/* Main Page Styling */


/* Header Styling */
#headPage {
  font-size: 2.5rem;
  font-weight: 800;

}

/* Dashboard Cards */
.cardRow {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 20px;
  margin-bottom: 30px;
}

.card {
  background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);
  border-radius: 16px;
  padding: 25px;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
}

.card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: linear-gradient(90deg, #4f46e5, #7c3aed);
}

.card:hover {
  transform: translateY(-5px);
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.15);
}

#startBalance::before {
  background: linear-gradient(90deg, #10b981, #059669);
}

#inCard::before {
  background: linear-gradient(90deg, #3b82f6, #2563eb);
}

#outCard::before {
  background: linear-gradient(90deg, #ef4444, #dc2626);
}

#balanceCard::before {
  background: linear-gradient(90deg, #8b5cf6, #7c3aed);
}

#titleCard {
  font-size: 0.9rem;
  font-weight: 600;
  color: #64748b;
  margin-bottom: 10px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

#amountCard {
  font-size: 2rem;
  font-weight: 700;
  color: #1e293b;
  margin: 0;
}

/* Filter Section */
.filterRow {
  background: white;
  border-radius: 20px;
  padding: 1.5rem;
  box-shadow: var(--card-shadow);
  margin-bottom: 1rem;
}

.filterGrid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(140px, 1fr));
  gap: 1rem;
}

.filterItem {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

#cardFilter {
  background: #f8fafc;
  border-radius: 8px;
  padding: 1rem;
  border: 2px solid #e2e8f0;
  transition: all 0.3s ease;
}

#cardFilter:hover {
  border-color: #667eea;
  background: white;
}

#inputTitle {
  font-weight: 600;
  color: #374151;
  margin-bottom: 0.5rem;
  font-size: 0.9rem;
}

/* Modern Form Controls */
.form-control,
.form-select {
  border: 2px solid #e2e8f0;
  border-radius: 10px;
  padding: 0.75rem 1rem;
  font-size: 0.9rem;
  transition: all 0.3s ease;
  background: white;
}

.form-control:focus,
.form-select:focus {
  border-color: #667eea;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
  outline: none;
}

/* Action Buttons - Now in pagination area */

.btn {
  border: 2px solid transparent;
  border-radius: 8px;
  padding: 0.5rem 1rem;
  font-weight: 600;
  font-size: 0.8rem;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  overflow: hidden;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  min-width: 80px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  white-space: nowrap;
  color: white;
}

.btn::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);
  transition: left 0.5s;
}

.btn:hover::before {
  left: 100%;
}



#resetFilter {
  color: white;
  box-shadow: var(--card-shadow);
}

#resetFilter:hover {
  transform: translateY(-2px);
  box-shadow: var(--card-shadow-hover);
}

#printer {
  border: 2px solid transparent;
  border-radius: 8px;
  transition: all 0.3s ease;
  box-shadow: var(--card-shadow);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  color: white;
}

#printer:hover {
  transform: translateY(-2px); 
  box-shadow: var(--card-shadow-hover);
}


/* Pagination */
.pageNation {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 2rem;
  width: 100%;
  padding: 0 1rem;
}

.actionButtons {
  display: flex;
  gap: 0.75rem;
  align-items: center;
  flex-shrink: 0;
  min-width: 400px;
  justify-content: flex-start;
}

.numberPage {
  display: flex;
  gap: 0.5rem;
  background: white;
  padding: 1rem;
  border-radius: 12px;
  box-shadow: var(--card-shadow);
}

#button-page {
  background: #d3e3f3;
  border: none;
  border-radius: 8px;
  padding: 0.5rem 1rem;
  color: #64748b;
  font-weight: 500;
  transition: all 0.3s ease;
  cursor: pointer;
}

#button-page:hover {
  background: var(--primary-gradient);
  color: white;
  transform: translateY(-2px);
}

#button-page.active {
  /* background: var(--primary-gradient); */
  color: rgb(0, 0, 0);
  box-shadow: var(--card-shadow);
}

/* Table Styling */
.tableRow {
  background: white;
  border-radius: 20px;
  overflow: hidden;
  box-shadow: var(--card-shadow);
  margin-bottom: 2rem;
}

#tableData {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.9rem;
}

#tableData thead {
  background: linear-gradient(135deg, #1e293b 0%, #334155 100%);
  color: white;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
}

#tableData th {
  padding: 1.5rem 1rem;
  /* text-align: left; */
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  border: none;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
  position: relative;
}

#tableData tbody tr {
  transition: all 0.3s ease;
  border-bottom: 1px solid #f1f5f9;
}

#tableData tbody tr:hover {
  background: #f8fafc;
  transform: scale(1.01);
}

#tableData tbody tr:nth-child(even) {
  background: #fafbfc;
}

#tableData td {
  padding: 0.5rem;
  border: none;
  vertical-align: middle;
}

#tableData .uang {
  font-family: 'Monaco', 'Menlo', monospace;
  font-weight: 600;
  color: #059669;
  font-size: 0.9rem;
}

.green-amount {
  color: #059669 !important; /* Hijau untuk type 1 */
}

.red-amount {
  color: #dc2626 !important; /* Merah untuk type 2 */
}

/* Action Buttons in Table */
#action button {
  background: none;
  border: none;
  padding: 0.5rem;
  border-radius: 8px;
  transition: all 0.3s ease;
  margin: 0 0.25rem;
}

#action button:hover {
  background: #e2e8f0;
  transform: translateY(-2px);
}

#action img {
  width: 20px;
  height: 20px;
}

/* Status Images */
#status {
  width: 24px;
  height: 24px;
}

#edited {
  width: 16px;
  height: 16px;
  margin-left: 0.5rem;
}

/* Modal Styling */
.modal-content {
  border-radius: 20px;
  border: none;
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
  overflow: hidden;
}

.modal-header {
  /* background: #c3c3c3; */
  color: #2563eb;
  padding: 2rem;
}

.modal-title {
  font-weight: 700;
  font-size: 1.25rem;
}

.modal-body {
  padding: 2rem;
  background: #fafbfc;
}

.modal-footer {
  border: none;
  padding: 1rem 2rem;
}

/* Modal Form */
#titleModal {
  font-weight: 600;
  color: #374151;
  margin-bottom: 0.5rem;
  font-size: 0.9rem;
}

/* Print Area */
#printArea {
  display: none;
  background: white;
  padding: 2rem;
  border-radius: 12px;
  box-shadow: var(--card-shadow);
}

.headPrint {
  text-align: center;
  margin-bottom: 2rem;
  padding-bottom: 1rem;
  border-bottom: 2px solid #e2e8f0;
}

#titlePrint {
  font-size: 1.5rem;
  font-weight: 700;
  color: #1e293b;
  margin-bottom: 0.5rem;
}

#brancName,
#datePrint {
  font-size: 1rem;
  color: #64748b;
  margin: 0;
}

.mainPrint {
  margin: 2rem 0;
}

#printTable {
  width: 100%;
  border-collapse: collapse;
}

#printTable td {
  padding: 0.75rem 0;
  border-bottom: 1px solid #e2e8f0;
}

#keyTable {
  font-weight: 600;
  color: #374151;
  width: 30%;
}

#titikDua {
  color: #64748b;
  width: 5%;
}

.signArea {
  margin-top: 3rem;
}

.signArea .inRow {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  gap: 2rem;
  text-align: center;
}

#name {
  font-weight: 600;
  color: #374151;
  margin-bottom: 1rem;
}

/* Loading Animation */
.lord-icon {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 2rem auto;
}

/* Additional Improvements */
.card {
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.2);
}

#amountCard {
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

/* Better button alignment */
.actionButtons {
  background: rgba(255, 255, 255, 0.9);
  backdrop-filter: blur(10px);
  border-radius: 12px;
  padding: 0.5rem;
  box-shadow: var(--card-shadow);
}

/* Responsive Design */
@media (max-width: 768px) {
  .mainPage {
    padding: 1rem;
  }

  #headPage {
    font-size: 2rem;
  }

  .cardRow {
    grid-template-columns: 1fr;
    gap: 1rem;
  }

  .card {
    padding: 1.5rem;
  }

  #amountCard {
    font-size: 1.5rem;
  }

  .inRow {
    grid-template-columns: 1fr;
    gap: 1rem;
  }

  .pageNation {
    flex-direction: column;
    gap: 1rem;
  }

  .actionButtons {
    justify-content: center;
    flex-wrap: wrap;
    gap: 0.5rem;
  }

  .filterGrid {
    grid-template-columns: repeat(auto-fit, minmax(120px, 1fr));
  }

  .btn {
    min-width: 70px;
    font-size: 0.75rem;
    padding: 0.4rem 0.8rem;
    height: 36px;
    margin: 0 0.25rem;
  }

  #printer {
    width: 36px;
    height: 36px;
    margin: 0 0.25rem;
  }

  .actionButtons {
    min-width: 300px;
    gap: 0.5rem;
  }

  #tableData {
    font-size: 0.8rem;
  }

  #tableData th,
  #tableData td {
    padding: 0.75rem 0.5rem;
  }

  .modal-body {
    padding: 1rem;
  }

  .modal-header {
    padding: 1.5rem;
  }
}

@media (max-width: 480px) {
  .mainPage {
    padding: 0.5rem;
  }

  .card {
    padding: 1rem;
  }

  .filterRow {
    padding: 1rem;
  }

  .filterGrid {
    grid-template-columns: 1fr;
    gap: 0.75rem;
  }

  .actionButtons {
    gap: 0.5rem;
    flex-wrap: wrap;
  }

  .btn {
    min-width: 70px;
    font-size: 0.7rem;
    padding: 0.4rem 0.6rem;
  }

  .numberPage {
    justify-content: center;
  }

  #cardFilter {
    padding: 0.75rem;
  }
}

/* Custom Scrollbar */
::-webkit-scrollbar {
  width: 8px;
}

::-webkit-scrollbar-track {
  background: #f1f5f9;
}

::-webkit-scrollbar-thumb {
  background: var(--primary-gradient);
  border-radius: 4px;
}

::-webkit-scrollbar-thumb:hover {
  background: linear-gradient(135deg, #5a67d8 0%, #6b46c1 100%);
}

/* Animation Classes */
.fade-in {
  animation: fadeIn 0.5s ease-in;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.slide-up {
  animation: slideUp 0.3s ease-out;
}

@keyframes slideUp {
  from {
    transform: translateY(100%);
  }
  to {
    transform: translateY(0);
  }
}

/* Enhanced Card Animations */
.card {
  animation: fadeIn 0.6s ease-out;
}

.card:nth-child(1) { animation-delay: 0.1s; }
.card:nth-child(2) { animation-delay: 0.2s; }
.card:nth-child(3) { animation-delay: 0.3s; }
.card:nth-child(4) { animation-delay: 0.4s; }

/* Additional Visual Enhancements */
.mainPage::before {
  content: '';
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background:
    radial-gradient(circle at 20% 80%, rgba(120, 119, 198, 0.1) 0%, transparent 50%),
    radial-gradient(circle at 80% 20%, rgba(255, 119, 198, 0.1) 0%, transparent 50%);
  pointer-events: none;
  z-index: -1;
}

/* Better text contrast for all elements */
#inputTitle {
  color: #374151;
  font-weight: 600;
}

#titleModal {
  color: #374151;
  font-weight: 600;
}

/* Enhanced table styling */
#tableData tbody tr:hover {
  background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
}

/* Better focus states */
.btn:focus {
  outline: none;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.3);
}

/* Enhanced filter styling */
.filterItem p {
  margin: 0 0 0.25rem 0;
  font-size: 0.75rem;
  font-weight: 600;
  color: #4b5563;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

/* Compact form controls */
.filterItem .form-control,
.filterItem .form-select {
  height: 36px;
  font-size: 0.8rem;
  border-radius: 6px;
}

/* Printer button styling */
#printer {
  width: 40px;
  height: 40px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
}

#printer img {
  width: 2rem;
  height: 1.6rem;
}

/* Additional enhancements */
.filterRow {
  position: relative;
  overflow: hidden;
}

.filterRow::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 2px;
  background: var(--primary-gradient);
}

/* Smooth transitions for all interactive elements */
.filterItem,
.actionButtons .btn,
#printer {
  transition: all 0.2s ease;
}

/* Enhanced button styling in pagination */


/* Better visual hierarchy */
.pageNation {
  position: relative;
  z-index: 1;
  width: 100%;
  min-height: 60px;
  background: transparent;
  padding: 1rem 0;
}

/* Ensure all buttons are visible */
.actionButtons .btn,
.actionButtons #printer {
  position: relative;
  z-index: 2;
  opacity: 1;
  visibility: visible;
}

/* Enhanced pagination styling */
.pageNation::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 2px;
  background: var(--primary-gradient);
  z-index: -1;
}



/* Ensure button container is always visible */
.pageNation .actionButtons {
  display: flex !important;
  background: transparent;
  padding: 12px !important;
  position: relative !important;
  z-index: 100 !important;
  width: auto !important;
  min-width: 300px !important;
}

/* Debug visibility - ensure no buttons are hidden */


.actionButtons .btn {
  display: flex !important;
  visibility: visible !important;
  opacity: 1 !important;
  border: 2px solid transparent !important;
  position: relative !important;
  z-index: 51 !important;
}

.actionButtons #addModal {
  position: relative !important;
  z-index: 51 !important;
  background-color: #059669 !important;
}

.actionButtons #resetFilter {
  position: relative !important;
  z-index: 51 !important;
}

.actionButtons #transferButton {
  background-color: #374151 !important;
  position: relative !important;
  z-index: 51 !important;
}


</style>
